function AppPageLayout({ children, maxWidthClassName = 'max-w-[1120px]' }) {
  return (
    <section className="px-4 py-5 sm:px-6 sm:py-6 lg:px-8 lg:py-8">
      <div className={`mx-auto w-full ${maxWidthClassName}`}>{children}</div>
    </section>
  );
}

export default AppPageLayout;
